import React from 'react';
import styled from 'styled-components';

function ButtonComponent(props: IButton) {
    return (
        <ButtonTag onClick={props.onClick} variant={props.variant}>
            {props.children}
        </ButtonTag>
    );
}

export default React.memo(ButtonComponent);

interface IButton {
    /**
     * 자식 Type
     */
    children?: React.ReactNode;
    /**
     * default : contained
     */
    variant?: 'contained' | 'outlined';

    type?: 'button' | 'submit' | 'reset';
    /**
     * onClick Event
     */
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

interface IButtonTag extends Pick<IButton, 'variant'> {}

export const ButtonTag = styled.button<IButtonTag>`
    min-width: 80px;
    height: ${({ theme }) => theme.defaultHeight.medium};
    cursor: pointer;
    border-radius: 8px;
    padding: 0 10px;

    background: ${({ variant, theme }) => (variant === 'outlined' ? 'none' : theme.color.point)};
    color: ${({ variant, theme }) => (variant === 'outlined' ? theme.color.point : 'white')};
    border: ${({ variant, theme }) => (variant === 'outlined' ? `1px solid ${theme.color.point}` : 'none')};

    &:hover {
        background: ${({ variant, theme }) => (variant === 'outlined' ? theme.color.point : 'none')};
        color: ${({ variant, theme }) => (variant === 'outlined' ? 'white' : theme.color.point)};
        border: ${({ variant, theme }) => (variant === 'outlined' ? 'none' : `1px solid ${theme.color.point}`)};
    }
`;
